import React from "react";
import SourcePanel from "./sections/SourcePanel";
import DestinationPanel from "./sections/DestinationPanel";
import "./CodeMigration.css";
import SplitPane from "react-split-pane";
import {useState, useContext} from "react";
import RepoContext from "../../context/Repos";

const CodeMigration = () => {

  return (
    <div className="migration-view">
      <SplitPane split="vertical" minSize={550} maxSize={-550} defaultSize="50%" allowResize={true}>
        <SourcePanel />
        <DestinationPanel />
      </SplitPane>
    </div>
  );
};

export default CodeMigration;
